// src/utils/statsigSSRStore.ts
// Global store for SSR feature flags to bridge Vike pages and React Router app

interface SSRStatsigData {
  initialFeatureFlags: Record<string, boolean>;
  initialExperiments: Record<string, any>;
}

let ssrStatsigData: SSRStatsigData = {
  initialFeatureFlags: {},
  initialExperiments: {}
};

export function setSSRStatsigData(data: Partial<SSRStatsigData>) {
  ssrStatsigData = {
    ...ssrStatsigData,
    ...data
  };
}

export function getSSRStatsigData(): SSRStatsigData {
  return ssrStatsigData;
}

export function clearSSRStatsigData() {
  ssrStatsigData = {
    initialFeatureFlags: {},
    initialExperiments: {}
  };
} 